import { Flex, FlexProps, Text } from '@mantine/core';
import React from 'react';

interface Props {
	label?: string;
	value: string | number;
	align?: FlexProps['align'];
}

export const FooterUniqueStat = ({ label, value, align }: Props) => {
	return (
		<Flex direction="column" align={align} w="100%">
			{label && (
				<Text fz="sm" c="dark.0">
					{label}
				</Text>
			)}
			<Text fz="md" fw={600}>
				{value}
			</Text>
		</Flex>
	);
};
